import { ApiResultError, CheckUtils, FileVoData, JabberFileData, } from "../..";
var FilesConverter = /** @class */ (function () {
    function FilesConverter() {
    }
    FilesConverter.convertToFilesData = function (filesVo) {
        if (CheckUtils.isEmpty(filesVo))
            return [];
        var result = [];
        filesVo.forEach(function (file) { return result.push(new JabberFileData(file.uid, file.name, file.contentType)); });
        return result;
    };
    FilesConverter.convertToFilesVoData = function (attachments) {
        if (CheckUtils.isEmpty(attachments))
            return [];
        var result = [];
        attachments.forEach(function (attachment) { return result.push(new FileVoData(attachment.identityKey == null ? attachment.identityKey : attachment.identityKey, attachment.name, attachment.contentType)); });
        return result;
    };
    FilesConverter.convertFromFilesApiResultDataToFilesVoData = function (values) {
        var result = [];
        if (!(values instanceof ApiResultError) && !CheckUtils.isEmpty(values.files)) {
            values.files.forEach(function (file) {
                result.push(new FileVoData(file.identityKey, file.name, file.contentType));
            });
        }
        return result;
    };
    return FilesConverter;
}());
export { FilesConverter };
//# sourceMappingURL=files-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/files-converter.js
// module id = 94
// module chunks = 14